/* eslint-disable max-len */
// PRICING API attributes
export const PRICING_URL = '/product-information/rental/inventory/pricing';
export const STORE_SERVICES_URL = '/StoreSearchServices/v2/storesearch';
export const SEARCH_DISTANCE = 100;
export const STORES_LIMIT = 5;

export const TOOL_PRICE_OPTIONS = {
  fourHourRate: ['4-Hours'],
  dailyRate: ['Per Day'],
  weeklyRate: ['Per Week', '3 Days FREE'],
  monthlyRate: ['4 Weeks', '12 Days FREE']
};

export const TOOL_PRICE_DELIVERY_OPTIONS = {
  dailyRate: ['Per Day'],
  weeklyRate: ['Per Week', '3 Days FREE'],
  monthlyRate: ['4 Weeks', '12 Days FREE']
};

export const VEHICLE_PRICE_OPTIONS = {
  seventyFiveMinutesRate: ['75-Minutes'],
  dailyRate: ['Per Day'],
  weeklyRate: ['Per Week']
};

// ItemIds for examples
export const TOOL_ITEMID = '316821412'; // Carpet Cleaner
export const VEHICLE_ITEMID = '316821410'; // Load-N-Go Van
export const LARGE_EQUIP_ITEMID = '316821721'; // Mini Excavator
export const SCISSOR_LIFT_ITEMID = '316821928'; // Scissor Lift
export const MINI_SKID_ITEMID = '316822124'; // Mini Skid Steer
export const BOOM_LIFT_ITEMID = '316821508'; // Boom Lift
export const BLACKLISTED_ITEMID = '316821727'; // Material Lift
export const DELIVERY_ONLY_LARGE_EQUIP_ITEMID = '316822174';

// Vehicle categories
export const VEHICLE_CATEGORIES = ['45', '65', '95'];
export const LARGE_EQUIPMENT_CATEGORIES = ['33'];
// hoisting license required
export const HOISTING_LICENSE_REQUIRED_SUB_CATEGORIES = ['395', '442', '396', '336', '588', '407', '486', '427', '428', '515', '419', '494', '335', '446', '513'];

export const PRICING_NOT_FOUND_MESSAGE = 'Pricing is unavailable at this location, please check a different location.';